module.exports = __webpack_public_path__ + "img/card.5c75e0d5.png";